import { Icon } from "@iconify/react";
import { Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import Breadcrumbs from "components/Breadcrumbs";
import SEO from "components/SEO";
import SessionContext from "components/session/SessionContext";
import Text from "components/Text";
import { pagePadding } from "data/commonClasses";
import { fetchPost, getTranslationContent, isArray } from "functions";
import Image from "next/image";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

const useStyles = makeStyles((theme) => ({
  title: {
    width: "100%",
    height: "auto",
    padding: "0 7.5%",
    margin: "1% 0",
    [theme.breakpoints.down("769")]: {
      width: "90%",
    },
  },
  subtitle: {
    borderLeftColor: "#F5B750",
    borderLeftStyle: "solid",
    borderLeftWidth: 7,
    fontSize: 26,
    color: "#344450",
    fontWeight: "bold",
    padding: "2% 3%",
    margin: "1% 0",
    [theme.breakpoints.down("1100")]: {
      borderLeftWidth: 5,
      fontSize: 22,
    },
    [theme.breakpoints.down("769")]: {
      borderLeftWidth: 3,
      fontSize: 18,
    },
  },
  tab: {
    display: "flex",
    width: "85%",
    margin: "0 auto",
    [theme.breakpoints.down("769")]: {
      width: "100%",
    },
    color: "#344450",
    backgroundColor: "#E4E4E4",
  },
  styleTab: {
    padding: "15px 0",
    [theme.breakpoints.down("1100")]: {
      fontSize: 14,
      padding: "14px 0",
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 12,
      padding: "12px 0",
    },
    [theme.breakpoints.down("400")]: {
      fontSize: 9,
      padding: "10px 0",
    },
    textAlign: "center",
  },
  item: {
    width: "auto",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#344450",
    backgroundColor: "#E4E4E4",
  },
  itemSelected: {
    color: "#FFFFFF",
    backgroundColor: "#344450",
  },
  container: {
    width: "85%",
    height: "auto",
    minHeight: 300,
    marginBottom: "3%",
    backgroundColor: "#F2F3F2",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    [theme.breakpoints.down("769")]: {
      width: "100%",
    },
  },
  containerContent: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    width: "85%",
    [theme.breakpoints.down("1100")]: {
      width: "95",
    },
    [theme.breakpoints.down("450")]: {
      width: "100%",
    },
    margin: "0 auto",
  },
  root: {
    "& .MuiInput-underline:after": {
      borderColor: "#F5B750",
      borderRadius: 0,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F5B750",
        borderRadius: 0,
      },
      "&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root": {
        color: "#F5B750",
      },
    },
    backgroundColor: "#FFFFFF",
    margin: "auto",
    marginTop: 20,
    marginBottom: 20,
    [theme.breakpoints.down("769")]: {
      marginTop: 10,
      marginBottom: 10,
    },
    width: "100%",
    [theme.breakpoints.down("600")]: {
      width: "90%",
    },
  },
  multilineColor: {
    color: "#344450",
    fontSize: 16,
    [theme.breakpoints.down("1100")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 12,
      height: 30,
    },
  },
  documentsContainer: {
    display: "flex",
    flexDirection: "column",
  },
  document: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
    alignSelf: "center",
    width: "100%",
    marginBottom: "2%",
    [theme.breakpoints.down("600")]: {
      width: "90%",
    },
    margin: "0 auto",
  },
  fileTitle: {
    color: "#344450",
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "85%",
    [theme.breakpoints.down("600")]: {
      fontSize: 13,
    },
  },
  actionIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "35%",
    justifyContent: "flex-end",
  },
  icon: {
    fontSize: 18,
    color: "#344450",
    [theme.breakpoints.down("1100")]: {
      fontSize: 16,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 14,
    },
    "&:hover": {
      color: "#F5B750",
    },
  },
  count: {
    marginRight: 5,
    fontSize: 15,
    color: "inherit",
    [theme.breakpoints.down("1100")]: {
      fontSize: 12,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 10,
    },
  },
}));

export default function TechnicalOfficePubs(props) {
  const classes = useStyles();
  const router = useRouter();
  const { t } = useTranslation();
  let pageData = props?.pageData || [];

  const category = router?.query?.category;
  let {
    session: {
      user: { _id, authToken },
      lang,
    },
  } = useContext(SessionContext);

  const [snackBarMessage, setSnackBarMessage] = useState(
    "Copied! Paste it in your favorite application"
  );
  const [snackBarOpen, setSnackBarOpen] = useState(false);

  async function handleShare(title, url) {
    if (navigator?.share) {
      navigator?.share({
        title: title,
        url: url,
      });
    } else {
      navigator?.clipboard?.writeText(url);
      setSnackBarOpen(true);
    }
  }

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t("technicalOfficePubs") },
  ];
  // if (typeof window != "undefined") console.log("Hello! ", window.innerWidth);
  // else console.log("Undefined");
  return (
    <div
      className={twMerge("flex flex-col w-full min-h-screen mb-5", pagePadding)}
    >
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackBarOpen(false)}
      >
        <Alert onClose={() => setSnackBarOpen(false)} severity="success">
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <SEO
        title={`${t("technicalOfficePubs")} - ${t("homeTitle").replace(
          "<br/>",
          ""
        )}`}
        description={t("technicalOfficePubs")}
      />
      <Breadcrumbs items={breadcrumbs} />
      <Text
        text={t("technicalOfficePubs")}
        bold
        sectionTitle
        className="my-5"
      />
      {/* <Box className={classes.tab}>
        {["All"].map((tab, i) => (
          <Link
            key={tab}
            href="/technicalOfficePubs/[category]"
            as={`/technicalOfficePubs/${categories[i]}`}
          >
            <Box
              className={
                category == categories[i]
                  ? classes.itemSelected + " " + classes.item
                  : classes.item
              }
              style={{ minWidth: i == 1 ? `50%` : `25%` }}
            >
              <Box className={classes.styleTab}>{t(tab)}</Box>
            </Box>
          </Link>
        ))}
      </Box> */}
      <div className={"bg-lightGrey p-5 rounded-button py-5"}>
        <div
          className={
            "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-start gap-5"
          }
        >
          {isArray(pageData) &&
            pageData?.length &&
            pageData?.map((document, index) => {
              let docTitle =
                getTranslationContent(document, "title", lang) ||
                document?.title;
              let pdfName = document?.pdfName;
              return (
                <div className="flex flex-col mb-2" key={index}>
                  <a
                    href={`https://oea-navybits.imgix.net/dms/forms/${pdfName}`}
                    alt="file"
                    target="_blank"
                    rel="noreferrer"
                    download
                    title={`${t("download")} ${pdfName}`}
                  >
                    <Image
                      src={`https://oea-navybits.imgix.net/dms/forms/${pdfName}?page=1&w=315`}
                      alt={docTitle}
                      height={600}
                      width={490}
                      className="rounded-button"
                    ></Image>
                  </a>

                  <div className="flex flex-row items-center justify-between">
                    <div>
                      <Text
                        bold
                        className="text-right text-infoText md:text-xl"
                        text={docTitle}
                      />
                    </div>
                    <div className="flex flex-row">
                      <div
                        onClick={() =>
                          handleShare(
                            docTitle,
                            `https://oea-navybits.imgix.net/dms/forms${pdfName}`
                          )
                        }
                      >
                        <Icon
                          icon={"material-symbols:share"}
                          className="mr-3 cursor-pointer text-sectionTitle text-black"
                        />
                      </div>
                      <a
                        href={`https://oea-navybits.imgix.net/dms/forms/${pdfName}`}
                        alt="file"
                        target="_blank"
                        rel="noreferrer"
                        download
                        title={`${t("download")} ${pdfName}`}
                      >
                        <Icon
                          icon={"ri:file-download-fill"}
                          className="mr-3 cursor-pointer text-sectionTitle text-black"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export async function getServerSideProps(context) {
  let { lang } = context?.query;

  let pageData = await fetchPost({
    apiName: `technical-office-publications/get`,
  });
  return {
    props: {
      lang,
      pageData: pageData?.response,
    },
  };
}
